<template>
  <nav class="navbar navbar-expand-lg navbar-absolute"
       :class="{'bg-white': showMenu, 'navbar-transparent': !showMenu}">
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div class="navbar-toggle d-inline" :class="{toggled: $sidebar.showSidebar}">
          <button type="button"
                  class="navbar-toggler"
                  aria-label="Navbar toggle button"
                  @click="toggleSidebar">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </button>
        </div>
        <a class="navbar-brand" :href="'#/' + routeName">{{routeName}}</a>
      </div>
      <button class="navbar-toggler" type="button"
              @click="toggleMenu"
              data-toggle="collapse"
              data-target="#navigation"
              aria-controls="navigation-index"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
      </button>

      <collapse-transition>
        <div class="collapse navbar-collapse show" v-show="showMenu">
          <ul class="navbar-nav ml-auto">
            <modal :show.sync="searchModalVisible"
                   class="modal-search"
                   id="searchModal"
                   :centered="false"
                   :show-close="true">
              <input slot="header" v-model="searchQuery" type="text" class="form-control" id="inlineFormInputGroup" placeholder="SEARCH">
            </modal>
            <div style="font-size: 30px; margin-left: 10px;" title="Unread tickets">
              <a href="#/tickets/?is_read=0" v-if="amount !== ''"><i class="tim-icons icon-chat-33"></i><p class="d-lg-none unread-amount">Unread tickets: <b>{{amount}}</b></p></a>
              <div v-else ><i class="tim-icons icon-chat-33"></i><p class="d-lg-none unread-amount">Unread tickets</p></div>
            </div>
            <p class="d-none d-lg-block d-xl-block" type="default" style="font-size: 10px; color: coral;">{{amount}}</p>
            <base-dropdown tag="li"
                           title-tag="a"
                           class="nav-item"
                           menu-classes="dropdown-navbar">
              <a slot="title" href="#" class="dropdown-toggle nav-link" data-toggle="dropdown" aria-expanded="true">
                <div class="photo">
                  <img src="img/default.png">
                </div>
                <b class="caret d-none d-lg-block d-xl-block"></b>
                <p class="d-lg-none">
                  Menu
                </p>
              </a>
              <li class="nav-link">
                <a href="#/Profile" class="nav-item dropdown-item">Profile</a>
              </li>
              <li class="nav-link">
                <a href="#" class="nav-item dropdown-item">Settings</a>
              </li>
              <div class="dropdown-divider"></div>
              <li class="nav-link">
                <a href="#" class="nav-item dropdown-item" @click="logout">Log out</a>
              </li>
            </base-dropdown>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </nav>
</template>
<script>
  import {url} from '../../plugins/axios'
  import { CollapseTransition } from 'vue2-transitions';
  import Modal from '@/components/Modal';
  import axios from "axios";
  import NotificationTemplate from "../../pages/Notifications/NotificationTemplate";

  function setCookie(cname, cvalue, exdays) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  export default {
    components: {
      CollapseTransition,
      Modal
    },
    computed: {
      routeName() {
        const { name } = this.$route;
        return this.capitalizeFirstLetter(name);
      },
    },
    data() {
      return {
        activeNotifications: false,
        showMenu: false,
        searchModalVisible: false,
        searchQuery: '',
        amount: "",
      };
    },
    methods: {
      notifyVue(type, message) {
        this.$notify({
          component: NotificationTemplate,
          icon: "tim-icons icon-bell-55",
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: type,
          message:message,
          timeout: 1500
        });
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications;
      },
      closeDropDown() {
        this.activeNotifications = false;
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      async getAmountNewTickets(){
       await axios
          .get(url + 'unread-tickets/myself',
            {
              withCredentials:'include',
              crossDomain:true
            })
          .then((response) => {
            if (response.data.error === ''){
              this.amount = response.data.result;
              setTimeout(()=>{this.getAmountNewTickets()},(1000 * 60 * 5));
            }
            else{
              if (response.data.error === 'Session is over'){
                setCookie('Authentication','Failed',1);
                this.$router.push('/login');
              }
            }
          });
      },
      logout() {
        setCookie('Authentication','',-1);
        setCookie('Project-id', '', -1);
        setCookie('Employee-id', '', -1);
        setCookie('User-id', '', -1);
        setCookie('Type-id', '', -1);

        axios
          .get(url + 'logout/',
            {
              withCredentials:'include',
              crossDomain:true
            }).then((response => {this.$router.push('/login');}));
      },
    },
    created() {
      this.getAmountNewTickets();
    }
  };
</script>
<style>
  .unread-amount{
    color: black;
    font-size: 14px;
    margin-left: 7px;
    display: inline-block;
    text-transform: uppercase;
  }
</style>
